import hatStyles, { type HatStyles } from "../1-style/hatStyles";

function getMaterials(hatStyles: HatStyles, style: string) {
	// Return the label field which matches the data-value attribute in the DOM
	return Object.entries(hatStyles[style].materials).map(([_, material]) => {
		return material.label; // e.g., "WOOL - $85"
	});
}

const styles = Object.keys(hatStyles);

const materials = styles.reduce(
	(acc, style) => {
		acc[style] = getMaterials(hatStyles, style);
		return acc;
	},
	{} as { [key: string]: string[] },
);

console.log("materials object for each style:", materials);
export { materials };
